import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

@Component({
  selector: 'app-widget-grid-card',
  templateUrl: './widget-grid-card.component.html',
  styleUrls: ['./widget-grid-card.component.scss', './widget-grid-card.component.en.scss']
})
export class WidgetGridCardComponent {
  @Input() open: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() modalTitle!: string;
  @HostBinding('class.mobile-modal') @Input() mobileModal: boolean = false;
  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();

  close() {
    this.closeModal.emit();
  }
}
